import * as React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import { fetchCards, fetchCompanies, fetchBanks, fetchTags } from 'src/actions';

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'src/assets/css/bootstrap.theme.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-tabs/style/react-tabs.css';
import 'react-quill/dist/quill.snow.css';
import 'src/assets/css/styles.css';

import * as Api from 'src/api';

import ContentContainer from './../Content';
import ContentCreateContainer from './../Content/create';
import ContentEditContainer from './../Content/edit';
import ContentSubtypeContainer from './../ContentSubtype';
import ContentSubtypeCreateContainer from './../ContentSubtype/create';
import ContentSubtypeEditContainer from './../ContentSubtype/edit';
import ModuleIndexContainer from './../Module';
import ModuleCreateContainer from './../Module/create';
import ModuleEditContainer from './../Module/edit';
import TagsIndexContainer  from '../Tags';
import TagsCreateContainer from '../Tags/create';
import TagsEditContainer from '../Tags/edit';

const getParameterByName = (name: string) => {
  name = name.replace(/[\[\]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(window.location.href);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

class AppContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.checkToken();
  }

  public render() {
    return (
      <Router>
        <section>
          <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <a className="navbar-brand" href="javascript:void(0)">
            <i className="fa fa-fire"></i> 
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/">Contenidos</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/subtipos-de-contenido">Subtipos de Contenidos</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/tags">Tags</Link>
                </li>
              </ul>
              <ul className="navbar-nav">
                <li className="nav-item active">
                  <a
                    className="nav-link"
                    href="javascript:void(0)"
                    onClick={this.logout}
                  >
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </nav>
          <div className="container-fluid" style={{ marginTop: '3%' }}>
            <div className="row">
              <div className="col">
                <Route exact path="/" component={ContentContainer} />
                <Route exact path="/crear" component={ContentCreateContainer} />
                <Route exact path="/editar/:id" component={ContentEditContainer} />
                <Route exact path="/subtipos-de-contenido" component={ContentSubtypeContainer} />
                <Route exact path="/subtipos-de-contenido/crear" component={ContentSubtypeCreateContainer} />
                <Route exact path="/subtipos-de-contenido/editar/:id" component={ContentSubtypeEditContainer} />
                <Route exact path="/modulos/:contentId" component={ModuleIndexContainer} />
                <Route exact path="/modulos/:contentId/crear" component={ModuleCreateContainer} />
                <Route exact path="/modulos/:contentId/editar/:id" component={ModuleEditContainer} />
                <Route exact path="/tags" component={TagsIndexContainer} />
                <Route exact path="/tags/crear" component={TagsCreateContainer} />
                <Route exact path="/tags/editar/:id" component={TagsEditContainer} />
              </div>
            </div>
          </div>
          <ToastContainer position="bottom-left"/>
        </section>
      </Router>
    );
  }

  private async checkToken() {
    const token = getParameterByName('token');
    if (token) {
      localStorage.setItem('token', token);

      console.log(localStorage.getItem('token'));
      window.location.href = '/';
    }

    const { data } = await Api.me();

    localStorage.setItem('user', JSON.stringify(data));
    this.getRemoteData();
  }

  private getRemoteData() {
    const {
      cards, banks, companies, tags,
    } = this.props;

    banks();
    cards();
    companies();
    tags();
  }

  private logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = String(process.env.REACT_APP_USERS_URL);
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    cards: () => dispatch(fetchCards()),
    banks: () => dispatch(fetchBanks()),
    companies: () => dispatch(fetchCompanies()),
    tags: () => dispatch(fetchTags()),
  };
};

export default connect(null, mapDispatchToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/containers/App/index.tsx